import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { isEmptyValue } from '@/utils/utils';

@Component({
    name: 'dropdown-select-check',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class DropdownSelectCheck extends Vue {

    @Prop()
    public listArray: any;

    @Prop()
    public selectedItemList: any;

    @Prop()
    public isMultiSelectCheckbox: any;

    @Prop()
    public headerText: any;

    @Prop()
    public isShowSelectAll: any;
    public searchTerms: any = '';
    public toggleDropdown: boolean = false;
    public selectedCheck: any = [];


    public customHeaderText: any = '';
    public singleSelect: any = {};

    public isAll: boolean = false;

    @Watch('headerText', { deep: true })
    public headerTextCheck(value: any) {
        this.customHeaderText = value;
    }

    @Watch('selectedItemList', { deep: true })
    public selectedItemListCheck(value: any) {
        this.selectedCheck = this.selectedItemList.map((items: any) => {
            return items.id;
        });
    }

    public created() {
        const headertext = this.headerText;
        this.customHeaderText = headertext;
    }

    public onSelectItem(selectedItem: any) {
        this.isAll = false;
        let selectedIndex;
        if (this.selectedItemList && this.selectedItemList.length > 0) {
            selectedIndex = this.selectedItemList.findIndex((item: any) => {
                return item.id === selectedItem.id;
            });
        }
        if (selectedIndex >= 0) {
            selectedItem.isSelected = false;
            this.selectedItemList.splice(selectedIndex, 1);
        } else {
            selectedItem.isSelected = true;
            this.selectedItemList.push(selectedItem);
        }

        this.selectedCheck = this.selectedItemList.map((items: any) => {
            return items.id;
        });
        this.$emit('onSelectItem', selectedItem);
        this.$emit('allSelectedItemList', this.selectedItemList);
    }

    private onSearchItemsText(value: any) {
        this.$emit('onSearchTerm', value);
    }

    private onSelectSingleClick(item: any) {
        this.selectedItemList = [];
        if (item === 'All') {
            this.customHeaderText = item;
            this.$emit('onSelectItem', item);
        } else {
            if (item && item.title) {
                this.selectedItemList.push(item);
                this.customHeaderText = item.title;

            } else {
                // this.customHeaderText = this.headerText;
            }
            this.searchTerms = '';
            this.onSearchItemsText('');
            this.$emit('onSelectItem', item);
            this.$emit('allSelectedItemList', this.selectedItemList);
        }
    }

    private onSelectAll(isAll: any) {
        const that = this;
        that.isAll = !that.isAll;
        if (!that.isAll) {
            for (const iterator of that.listArray) {
                let selectedIndex = -1;
                if (that.selectedItemList && that.selectedItemList.length > 0) {
                    selectedIndex = that.selectedItemList.findIndex((item: any) => {
                        return item.id === iterator.id;
                    });
                }
                if (selectedIndex >= 0) {
                    iterator.isSelected = false;
                    that.selectedItemList.splice(selectedIndex, 1);
                    that.selectedCheck = that.selectedItemList.map((items: any) => {
                        return items.id;
                    });
                    that.$emit('onSelectItem', iterator);
                    that.$emit('allSelectedItemList', that.selectedItemList);
                }
            }
        } else {
            for (const iterator of that.listArray) {
                let selectedIndex = -1;
                if (that.selectedItemList && that.selectedItemList.length > 0) {
                    selectedIndex = that.selectedItemList.findIndex((item: any) => {
                        return item.id === iterator.id;
                    });
                }
                if (selectedIndex === -1) {
                    iterator.isSelected = true;
                    that.selectedItemList.push(iterator);
                }
                that.selectedCheck = that.selectedItemList.map((items: any) => {
                    return items.id;
                });
                that.$emit('onSelectItem', iterator);
                that.$emit('allSelectedItemList', that.selectedItemList);
            }
        }
    }
}
